module.exports = __webpack_public_path__ + "static/media/dapper.4741ed31.png";